module.exports = __webpack_public_path__ + "static/media/logout.415227a2.svg";